module.exports = __webpack_public_path__ + "static/img/no_data_pic.a6801e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_data_pic.png
// module id = VNFI
// module chunks = 1